import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.button`
    display: flex;
    flex-direction: column;
    width: 90%;
    border-radius: 5px;
    height: fit-content;
    cursor: ${({$isAlarm})=> $isAlarm ? 'pointer' : 'auto'};
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    background: ${({ $background }) => $background ? $background : '#F6F6F6'};
    box-shadow: ${({ $alarm }) => {return (
        $alarm === 1 ? '2px 2px 0px 0px #EABC1A' : 
        $alarm === 2 ? '2px 2px 0px 0px #FF3939' :
        $alarm === 3 ? '2px 2px 0px 0px #60C' :
        $alarm === 4 ? '2px 2px 0px 0px #E1800E' :
        $alarm === 6 ? '2px 2px 0px 0px #00375E' :
        '0px 1.51735px 1.51735px 1px rgba(0, 0, 0, 0.25)')}};
    @media (orientation: landscape) and (max-width: 1200px){
        min-width: 280px;
    }
`;

export const ContainerRow = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 90%;
    border-radius: 5px;
    height: fit-content;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    cursor: ${({$isAlarm})=> $isAlarm ? 'pointer' : 'auto'};
    background: ${({ $background }) => $background ? $background : '#F6F6F6'};
    box-shadow: ${({ $alarm }) => {return (
        $alarm === 1 ? '2px 2px 0px 0px #EABC1A' : 
        $alarm === 2 ? '2px 2px 0px 0px #FF3939' :
        $alarm === 3 ? '2px 2px 0px 0px #60C' :
        $alarm === 4 ? '2px 2px 0px 0px #E1800E' :
        $alarm === 6 ? '2px 2px 0px 0px #00375E' :
        '0px 1.51735px 1.51735px 1px rgba(0, 0, 0, 0.25)')}};
    @media (orientation: landscape) and (max-width: 1200px){
        min-width: 280px;
    }
`;

export const Line = styled.div`
    display: flex;
    flex-direction: row;
    padding-inline: 10px;
    padding-block: ${({ $lower }) => $lower ? '' : '5px'};
    min-height: 30px;
    width: 100%;
    justify-content: center;
    align-items: center;
    filter: ${({ $inative }) => $inative ? 'grayscale(100%)' : ''};
    opacity: ${({ $inative }) => $inative ? '0.5' : '1'};
    pointer-events: ${({ $inative }) => $inative ? 'none' : 'auto'};
    @media (orientation: landscape) and (max-width: 1200px){
        width: 98%;
    }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${({ $justify }) => $justify ? $justify : 'center'};
    align-items: ${({ $align }) => $align ? $align : 'center'};
    width: ${({ $width }) => $width};
`;

export const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
`

export const NumberInput = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 48px;
    border-radius: 3.802px;
    border: 1.14px solid #C4C4C4;
    outline: none;
    height: 24px;
    background: #FFF;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: ${props => (props.isNewValue ? '#4361EE' : '#333')};
    font-size: 12px;
    font-weight: 600; 
    font-style: normal;
    line-height: 0;
    scale: ${({ scale }) => scale ? scale : 1};
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
    @media (min-width: 1281px) {
        font-size: 15px;
    }
`;

export const ItemContainer = styled.div`
    display: ${(props) => (props.$invisible === true ? 'none' : 'flex')};
    flex-direction: column;
    width: 100%;
    min-width: 315px;
    background: transparent;
    gap: 5px;
    transition: 1s;
    filter: ${(props) => (props.$Active === true ? 'none' : 'grayscale(100%)')};
    opacity: ${(props) => (props.$Active === true ? '1' : '0.5')};
    @media (orientation: landscape) and (max-width: 1200px){
        min-width: 285px;
    }
    
`;

export const ChildContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: transparent;
    padding: 2.5px;
    width: 100%;
    gap: 5px;
    opacity: ${(props) => (props.$show ? 1 : 0)};
    max-height: ${(props) => (props.$show ? '100%' : '0')};
    overflow: hidden;
    transition: max-height 1s, opacity 1s;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`;

export const ItemName = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #006560;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    background: transparent;
    border: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    @media (min-width: 1281px) {
        font-size: 18px;
    }
`;

export const NameContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 20px;
    border-radius: 5px;
    background: #F6F6F6;
    min-height: 45px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    margin-bottom: 5px;
    @media (orientation: landscape) and (max-width: 1200px){
        width: 97%;
    }
`;

export const Text = styled.h1`
    color: #333;
    font-size: 12px;
    font-style: normal;
    font-weight: ${({ $weight }) => $weight ? $weight : '400'};
    text-align: left;
    max-width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    @media (min-width: 1281px) {
        font-size: 15px;
    }
        
`;

export const CountAlarms = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline: 5px;
    border-radius: 50%;
    color: #F6F6F6;
    background: ${({ $background }) => $background ? $background : 'transparent'};
`;

export const StateIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: ${({ State }) => State ? '#3C3' : '#FF3939'};
    color: #F6F6F6;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 8.743px;
    @media (min-width: 1281px) {
        width: 20px;
        height: 20px;
        font-size: 15px;
    }
`;

export const AlarmConfig = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${({$isAlarm})=> $isAlarm ? 'pointer' : 'auto'};
    width: 10%;
`;

export const ContainerPump = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px; 
    width: 100%;
    min-width: 310px;
`

export const HelpIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: currentColor;
    }
`;

export const Icon = styled(SVG)`
    height: 18px;
    width: 18px;
    & path {
        fill: currentColor;
    }
`;